import React from 'react';

const BackgroundVideo = () => {
  const videoStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    objectFit: 'cover',
    zIndex: -1,  // Ensure it's behind the rest of the content
    filter: 'brightness(80%)',  // Optional: Darken the video slightly to improve readability of the content
  };

  const containerStyle = {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    overflow: 'hidden',
    zIndex: -1, // Make sure this container stays behind the content
  };

  return (
    <div style={containerStyle}>
      <video
        style={videoStyle}
        autoPlay
        loop
        muted
        playsInline
        onError={() => console.log('Error loading video. Check file path or format.')}
      >
        <source src={require('../videos/1.mp4')} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default BackgroundVideo;
